import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { tr } from 'date-fns/locale';
// import { batchUploadFile } from '@/api/commonApi.js';
import Cookie from 'js-cookie';
import moment from 'moment';
import { saveRepairRegistration, queryRepair, delRepairRegistration, queryRepairDetail, editSaveRepairRegistration, subRepairRegistration, batchUploadFile } from '@/api/repairs/repairsApi.js';
import config from '@/pathConfig';
import { forEach } from 'min-dash';
var Base64 = require('js-base64').Base64;
import { format, parseISO } from 'date-fns';
export default {
  data: function data() {
    return {
      visibleShow: false,
      //删除显示
      visibleShowId: '',
      //删除显示id判断
      editfileList: [],
      //修改提交的文件列表
      dateFormat: 'YYYY-MM-DD',
      //时间格式
      config: config,
      //label格式
      labelCol: {
        span: 7
      },
      wrapperCol: {
        span: 16
      },
      //表单删选
      form: {
        repairsStatus: undefined,
        //维修状态
        queryStr: undefined,
        //模糊查询
        time: [],
        //选择时间存储
        startTime: null,
        //开始时间
        endTime: null //结束时间
      },
      paginationTable: this.$hdk.page(),
      //分页索引
      tableData: [],
      //表单内容存储
      //表单标头
      columns: [{
        title: '报修单号',
        dataIndex: 'number'
      }, {
        title: '联系电话',
        dataIndex: 'phone'
      }, {
        title: '设备名称',
        dataIndex: 'itemName',
        ellipsis: true
      }, {
        title: '设备位置',
        dataIndex: 'location',
        ellipsis: true
      }, {
        title: '组织岗位',
        dataIndex: "userDepartment",
        ellipsis: true
        // scopedSlots: { customRender: 'drafterTemp' }
      }, {
        title: '故障时间',
        dataIndex: 'reDate'
      }, {
        title: '故障描述',
        dataIndex: 'description',
        ellipsis: true
      }, {
        title: '维修状态',
        dataIndex: 'repairsStatus',
        scopedSlots: {
          customRender: 'repairsStatus'
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      //新增保修单显示判断
      addRigisterStatus: false,
      //新建报修人填写对象
      addForm: {
        fileList: [],
        makeServiceDate: '',
        faultImgList: [],
        createPerson: undefined,
        //报修人
        createPersonPhone: undefined,
        //报修电话
        itemName: undefined,
        //设备名称
        itemModel: undefined,
        //设备型号
        equipmentNumber: undefined,
        //设备编号
        location: undefined,
        //设备位置
        formObject: {},
        //使用部门
        organPostId: [],
        faultTime: undefined,
        //故障时间
        description: undefined,
        //设备描述
        repairsStatus: '' //报修状态
      },
      //新建报修人校验规则
      addFormRules: {
        createPerson: [{
          required: true,
          message: '请填写报修人',
          trigger: 'blur'
        }],
        createPersonPhone: [{
          required: true,
          message: '请填写电话',
          trigger: 'blur'
        }],
        itemName: [{
          required: true,
          message: '请填写设备名称',
          trigger: 'blur'
        }],
        itemModel: [{
          required: true,
          message: '请填写设备型号',
          trigger: 'blur'
        }],
        // equipmentNumber: [{ required: true, message: '请填写设备编号', trigger: 'blur' }],
        location: [{
          required: true,
          message: '请填写设备位置',
          trigger: 'blur'
        }],
        organPostId: [{
          required: true,
          message: '请填写使用部门',
          trigger: ['change']
        }],
        faultTime: [{
          required: true,
          message: '请选择故障时间',
          trigger: 'change'
        }],
        description: [{
          required: true,
          message: '请填写故障描述',
          trigger: 'blur'
        }]
      },
      //修改报修人填写对象
      editForm: {
        faultImgList: [],
        makeServiceDate: '',
        userName: undefined,
        //报修人
        phone: undefined,
        //联系电话
        itemName: undefined,
        //设备名称
        itemModel: undefined,
        //设备型号
        itemNum: undefined,
        //设备编号
        location: undefined,
        //设备位置
        organPostId: [],
        //使用部门
        reDate: undefined,
        //故障时间
        description: undefined,
        //故障描述
        fileList: [],
        //附件
        repairsStatus: '' //报修状态 0草稿 1提交
      },
      //
      //修改报修人校验规则
      editFormRules: {
        userName: [{
          required: true,
          message: '请填写报修人',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请填写电话',
          trigger: 'blur'
        }],
        itemName: [{
          required: true,
          message: '请填写设备名称',
          trigger: 'blur'
        }],
        itemModel: [{
          required: true,
          message: '请填写设备型号',
          trigger: 'blur'
        }],
        // equipmentNumber: [{ required: true, message: '请填写设备编号', trigger: 'blur' }],
        location: [{
          required: true,
          message: '请填写设备位置',
          trigger: 'blur'
        }],
        organPostId: [{
          required: true,
          message: '请填写使用部门',
          trigger: 'change'
        }],
        reDate: [{
          required: true,
          message: '请选择故障时间',
          trigger: 'change'
        }],
        description: [{
          required: true,
          message: '请填写故障描述',
          trigger: 'blur'
        }]
      },
      previewShow: false,
      //图片显示模块控制
      editRigisterStatus: false,
      //修改保修单显示判断
      defaultValue: [],
      imageUrl: '',
      //图片路径
      options: [],
      // 级联选择数据
      userInfo: this.$hdk.userInfo.get(),
      loading: false,
      //表格加载动画
      newImgList: [] //修改删除已提交的图片并保存
    };
  },
  created: function created() {
    var savedPagination = sessionStorage.getItem('Pagination_register');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.paginationTable.current = parsed.current || 1;
        this.paginationTable.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }

    //获取用户信息
    var userInfo = this.userInfo;
    this.addForm.createPerson = userInfo.userName;
    this.addForm.createPersonPhone = userInfo.mobile;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null,
          type: subItem.typeId
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList,
        type: item.typeId
      };
    });
    this.getQueryRepair(); //获取报修登记列表
  },
  methods: {
    moment: moment,
    /**
     * 列表提交
     */
    listSubmit: function listSubmit(data) {
      var _this = this;
      subRepairRegistration(data).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success('提交成功', 10);
          _this.getQueryRepair();
        } else {
          _this.$message.error('提交失败', 10);
        }
      });
    },
    /**
     * 修改表单时删除已上传的图片并合并成新的图片数组提交
     */
    deletImg: function deletImg(data) {
      var newImgList = [];
      this.newImgList.forEach(function (item, index) {
        if (item.id != data.id) {
          newImgList.push(item);
        }
      });
      this.newImgList = newImgList;
    },
    /**
     * 条件筛选查找
     */
    searchSubmit: function searchSubmit() {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = 10;
      this.getQueryRepair();
      sessionStorage.removeItem('Pagination_register');
    },
    /**
     *切换分页时调用
     */
    change: function change(pagination) {
      this.getQueryRepair({
        current: pagination.current,
        pageSize: pagination.pageSize,
        form: this.form
      });
      sessionStorage.setItem('Pagination_register', JSON.stringify(this.pagination));
    },
    /**
     * 获取报修登记列表
     */
    getQueryRepair: function getQueryRepair(options) {
      var _this2 = this;
      var paginationTable = this.paginationTable,
        form = this.form,
        pager = _.assign({}, paginationTable, options);
      this.loading = true;
      if (this.form.time.length > 0) {
        this.form.startTime = this.form.time[0];
        this.form.endTime = this.form.time[1];
      } else {
        this.form.startTime = null;
        this.form.endTime = null;
      }
      if (!pager.form) {
        pager.form = form;
      }
      // return;
      queryRepair(pager.current, pager.pageSize, pager.form).then(function (res) {
        _this2.tableData = res.data.data;
        _.assign(paginationTable, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(form, pager.form);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /**
     * 新增报修单 提交文件删除
     */
    delFile: function delFile(data) {
      var addForm = this.addForm;
      if (1 === addForm.fileList.length) {
        this.addForm.fileList = [];
        // this.formObject.attach = [];
      } else {
        var evens = _.remove(addForm.fileList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.addForm.fileList = evens;
        // this.formObject.attach = evens;
      }
    },
    /**
     * 修改报修单 上传文件删除
     */
    reviseDelFile: function reviseDelFile(data) {
      var editfileList = this.editfileList;
      if (1 === editfileList.length) {
        this.editfileList = [];
        // this.formObject.attach = [];
      } else {
        var evens = _.remove(editfileList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.editfileList = evens;
        // this.formObject.attach = evens;
      }
    },
    /**
     * 新增报修单 文件上传存值
     */
    actionUpload: function actionUpload(data) {
      var $message = this.$message,
        addForm = this.addForm;
      if (addForm.fileList.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.addForm.fileList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    /**
     * 修改报修单 文件上传存值
     */
    reviseActionUpload: function reviseActionUpload(data) {
      var $message = this.$message,
        editfileList = this.editfileList;
      if (editfileList.length >= 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.editfileList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    /**
     * 上传文件大小判断
     */
    beforeUpload: function beforeUpload(file) {
      var $message = this.$message;
      var isLt1M = file.size / 1024 / 1024 < 500;
      if (!isLt1M) {
        $message.error('最大只能上传500MB');
      }
      return isLt1M;
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      var $set = this.$set,
        addForm = this.addForm;
      // 组织岗位赋值
      $set(addForm.formObject, 'organId', value[0]);
      $set(addForm.formObject, 'postId', value[1]);
      $set(addForm.formObject, 'typeId', option[0].type);
    },
    /**
     * 级联选择筛选
     */
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    /**
     * 点击删除显示是否删除按钮
     */
    changeClear: function changeClear(e) {
      this.visibleShowId = e.id;
      // document.getElementById('btnn').click();
      this.visibleShow = true;
    },
    /**
     * 点击评价跳转页面
     */
    evaluationClick: function evaluationClick(row) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: row.id,
          mode: 'evaluation',
          backTo: 'register',
          repairsStatus: row.repairsStatus
        }
      });
      // this.evaluation = true;
    },
    /**
     * 点击新增报修单触发
     */
    addRigister: function addRigister() {
      var $set = this.$set,
        addForm = this.addForm,
        options = this.options;
      addForm.organPostId = [options[0].value, options[0].children[0].value];
      // 组织岗位赋值
      $set(addForm.formObject, 'organId', addForm.organPostId[0]);
      $set(addForm.formObject, 'postId', addForm.organPostId[1]);
      $set(addForm.formObject, 'typeId', options[0].type);
      this.addRigisterStatus = true; //新增报修单弹窗显示
    },
    /**
     * 新增报修单 报修提交
     */
    addSbumit: function addSbumit() {
      var _this3 = this;
      //repairsStatus 报修状态(0草稿,1提交) 有坑！
      this.addForm.repairsStatus = 1;
      //校验rules判断是否通过
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          //调用报修登记接口进行提交 有坑应该调用subRepairRegistration
          saveRepairRegistration(_this3.addForm).then(function (res) {
            if (res.data.code == 200) {
              //提交成功提示
              _this3.$message.success('提交成功', 10);
              //隐藏 新增报修单
              _this3.addRigisterStatus = false;
              //提交成功清空新增保修单里面的数据
              _this3.$refs.addForm.resetFields();
              //刷新列表
              _this3.getQueryRepair();
            } else {
              //提交失败提示
              _this3.$message.success('提交失败', 10);
            }
          });
        } else {
          return false;
        }
      });
    },
    addRigisterSubmit: function addRigisterSubmit() {
      var _this4 = this;
      //判断文件存储的数组长度
      if (this.addForm.fileList.length > 0) {
        //将文件中的值由newFileObj接收
        var newFileObj = _.map(this.addForm.fileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            //将上传后返回的数据添加到数组中
            _.map(res.data.data, function (item) {
              _this4.addForm.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this4.addSbumit(); //进行保存校验提交
          });
        } else {
          this.addSbumit(); //进行保存校验提交
        }
      } else {
        this.addSbumit(); //进行保存校验提交
      }
    },
    /**
     * 新增报修单 报修保存
     */
    addSave: function addSave() {
      var _this5 = this;
      //repairsStatus 报修状态(0草稿,1提交)
      this.addForm.repairsStatus = 0;
      //校验rules判断是否通过
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          //调用报修登记接口进行保存
          saveRepairRegistration(_this5.addForm).then(function (res) {
            if (res.data.code == 200) {
              //提交成功提示
              _this5.$message.success('提交成功', 10);
              //隐藏 新增报修单
              _this5.addRigisterStatus = false;
              //提交成功清空新增保修单里面的数据
              _this5.$refs.addForm.resetFields();
              //刷新列表
              _this5.getQueryRepair();
            } else {
              //提交失败提示
              _this5.$message.success('提交失败', 10);
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 新增报修单 报修保存点击时，判断并上传文件
     */
    addSaveSubmit: function addSaveSubmit() {
      var _this6 = this;
      //判断文件存储的数组长度
      if (this.addForm.fileList.length > 0) {
        //将文件中的值由newFileObj接收
        var newFileObj = _.map(this.addForm.fileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            //将上传后返回的数据添加到数组中
            _.map(res.data.data, function (item) {
              _this6.addForm.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this6.addSave(); //进行保存校验提交
          });
        } else {
          this.addSave(); //进行保存校验提交
        }
      } else {
        this.addSave(); //进行保存校验提交
      }
    },
    //新增报修单 点击返回方法
    addRigisterCancel: function addRigisterCancel() {
      this.addRigisterStatus = false; //隐藏新增保修单
      this.$refs.addForm.resetFields(); //清除新增保修单数据
    },
    //修改报修单时查看 新增报修单时提交的图片
    handlePreview: function handlePreview(data) {
      var url = data.url;
      var fileUrl = config.baseUrl + url;
      // this.imageUrl = fileUrl;

      window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl)), '_blank');

      // this.previewShow = true;
      // this.config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl));
      // console.log(this.imageUrl);
    },
    //隐藏查看图片窗口
    handleCancel: function handleCancel() {
      this.previewShow = false;
    },
    /**
     * 点修改报修查询
     */
    editRigister: function editRigister(row) {
      var _this7 = this;
      this.editfileList = [];
      queryRepairDetail(row.id).then(function (res) {
        _this7.editForm = res.data.data;
        _this7.editForm.organPostId = [];
        _this7.defaultValue = [];
        _this7.editForm.organPostId.push(Number(_this7.editForm.organId));
        _this7.editForm.organPostId.push(Number(_this7.editForm.postId));
        _this7.editForm.faultImgList.forEach(function (item, index) {
          _this7.editForm.faultImgList[index].uid = item.id;
          _this7.editForm.faultImgList[index].name = item.faultImgName;
          _this7.editForm.faultImgList[index].url = item.faultImgPath;
          _this7.editForm.faultImgList[index].status = 'done';
        });
        _this7.newImgList = _this7.editForm.faultImgList;
        _this7.editRigisterStatus = true;
      });
    },
    /**
     * 修改报修提交
     */
    editRigisterSubmit: function editRigisterSubmit() {
      var _this8 = this;
      if (this.editfileList.length > 0) {
        var newFileObj = _.map(this.editfileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          this.editForm.editSaveList = [];
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this8.editForm.editSaveList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this8.editSubmit();
          });
        } else {
          this.editSubmit();
        }
      } else {
        this.editSubmit();
      }
    },
    editSubmit: function editSubmit() {
      var _this9 = this;
      this.editForm.repairsStatus = 1;
      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          if (_this9.editForm.editSaveList != undefined && _this9.editForm.editSaveList.length > 0) {
            var newImgList = _this9.newImgList.concat(_this9.editForm.editSaveList);
            _this9.editForm.editSaveList = newImgList;
          } else {
            _this9.editForm.editSaveList = _this9.newImgList;
          }
          editSaveRepairRegistration(_this9.editForm).then(function (res) {
            if (res.data.code == 200) {
              _this9.$message.success('提交成功', 10);
              _this9.editRigisterStatus = false;
              _this9.getQueryRepair();
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 修改报修保存
     */
    editSave: function editSave() {
      var _this0 = this;
      this.editForm.repairsStatus = 0;
      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          if (_this0.editForm.editSaveList != undefined && _this0.editForm.editSaveList.length > 0) {
            var newImgList = _this0.newImgList.concat(_this0.editForm.editSaveList);
            _this0.editForm.editSaveList = newImgList;
          } else {
            _this0.editForm.editSaveList = _this0.newImgList;
          }
          editSaveRepairRegistration(_this0.editForm).then(function (res) {
            if (res.data.code == 200) {
              _this0.$message.success('提交成功', 10);
              _this0.editRigisterStatus = false;
              _this0.getQueryRepair();
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 修改报修单 图片上传保存
     */
    editSaveSubmit: function editSaveSubmit() {
      var _this1 = this;
      if (this.editfileList.length > 0) {
        var newFileObj = _.map(this.editfileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          this.editForm.editSaveList = [];
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this1.editForm.editSaveList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this1.editSave();
          });
        } else {
          this.editSave();
        }
      } else {
        this.editSave();
      }
    },
    /**
     * 修改报修单点击取消隐藏
     */
    editRigisterCancel: function editRigisterCancel() {
      this.editRigisterStatus = false;
    },
    /**
     * 点击查看跳转
     */
    viewRigister: function viewRigister(row) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: row.id,
          mode: 'view',
          backTo: 'register',
          repairsStatus: row.repairsStatus
        }
      });
    },
    /**
     * 删除草稿
     */
    deleteRigister: function deleteRigister(id) {
      var _this10 = this;
      delRepairRegistration(id).then(function (res) {
        _this10.getQueryRepair();
      });
    },
    deleteCancel: function deleteCancel() {
      this.visibleShow = false;
    }
  }
};